import type { SelectOptionType } from "@ui/components/DEPRECATED_CustomSelect";

import type { Config } from "@jti/fe-common";
import { leftToRightMark } from "@jti/fe-common";

export const getCountriesCodesArray = (config: Config): SelectOptionType[] => {
  return (config.TELEPHONE_CODES_LIST || "").split(",").map((value) => ({
    value,
    label: `${leftToRightMark}${value}`,
  }));
};
